<script setup lang="ts">
    import { computed } from 'vue'
    import { ErrorData, getViolationsFeedback } from '@/js/utils'

    const emit = defineEmits(['update:modelValue'])

    export interface Props {
        modelValue: string
        label?: string
        hint?: string
        placeholder?: string
        dataTest?: string
        error?: ErrorData
        violationFields?: string[]
        isLoading?: boolean
        disabled?: boolean
    }

    const props = withDefaults(defineProps<Props>(), {
        label: '',
        hint: '',
        placeholder: '',
        violationFields: () => [] as string[],
        dataTest: '',
        error: () => {
            return {} as ErrorData
        },
        isLoading: false,
        disabled: false
    })

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })

    const errorMessages = computed(() => {
        return props.error ? getViolationsFeedback(props.violationFields, props.error) : ''
    })
</script>

<template>
    <v-textarea
        v-model="value"
        :disabled="isLoading || disabled"
        minlength="1"
        maxlength="3500"
        :label="label"
        :placeholder="placeholder"
        :data-test="dataTest"
        rows="3"
        trim
        max-rows="15"
        rounded="0"
        auto-grow
        variant="outlined"
        density="compact"
        :hint="hint"
        :persistent-hint="!!hint"
        hide-details="auto"
        :error-messages="errorMessages"
        :error="!!errorMessages?.length"
    />
</template>

<style scoped></style>
